module.exports = __webpack_public_path__ + "img/1-ilpakamaniPRENSA_thumb.29d9b59f.jpg";